<template>
  <div class="row-image-container" :class="imageDenied ? 'denied-by-mod' : ''">
    <div class="row-image-image selectable" @click="goToDetail">
      <img v-if="signedUrl" :src="signedUrl" :alt="description">
    </div>
    <div class="row-image-info">
      <h3 class="image-name selectable" @click="goToDetail">{{ title }} <span class="upload-date">{{
          formatDateUS(publicationDate)
        }}</span></h3>
      <div v-if="!imageDenied" class="publish-state-container">
        <svg v-if="published" xmlns="http://www.w3.org/2000/svg" width="16" height="16"
             fill="currentColor"
             class="bi bi-eye-fill" viewBox="0 0 16 16">
          <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0"/>
          <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8m8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7"/>
        </svg>
        <svg v-if="!published" xmlns="http://www.w3.org/2000/svg" width="16" height="16"
             fill="darkgray" class="bi bi-eye-slash-fill" viewBox="0 0 16 16">
          <path
              d="m10.79 12.912-1.614-1.615a3.5 3.5 0 0 1-4.474-4.474l-2.06-2.06C.938 6.278 0 8 0 8s3 5.5 8 5.5a7 7 0 0 0 2.79-.588M5.21 3.088A7 7 0 0 1 8 2.5c5 0 8 5.5 8 5.5s-.939 1.721-2.641 3.238l-2.062-2.062a3.5 3.5 0 0 0-4.474-4.474z"/>
          <path
              d="M5.525 7.646a2.5 2.5 0 0 0 2.829 2.829zm4.95.708-2.829-2.83a2.5 2.5 0 0 1 2.829 2.829zm3.171 6-12-12 .708-.708 12 12z"/>
        </svg>
        <p>{{ published ? 'Published' : 'Private' }}
          <span v-if="!reviewed" class="review-message">(In review by moderator)</span>
        </p>
      </div>
      <div v-if="!imageDenied" class="image-likes-container">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
             class="bi bi-hand-thumbs-up-fill" viewBox="0 0 16 16">
          <path
              d="M6.956 1.745C7.021.81 7.908.087 8.864.325l.261.066c.463.116.874.456 1.012.965.22.816.533 2.511.062 4.51a10 10 0 0 1 .443-.051c.713-.065 1.669-.072 2.516.21.518.173.994.681 1.2 1.273.184.532.16 1.162-.234 1.733q.086.18.138.363c.077.27.113.567.113.856s-.036.586-.113.856c-.039.135-.09.273-.16.404.169.387.107.819-.003 1.148a3.2 3.2 0 0 1-.488.901c.054.152.076.312.076.465 0 .305-.089.625-.253.912C13.1 15.522 12.437 16 11.5 16H8c-.605 0-1.07-.081-1.466-.218a4.8 4.8 0 0 1-.97-.484l-.048-.03c-.504-.307-.999-.609-2.068-.722C2.682 14.464 2 13.846 2 13V9c0-.85.685-1.432 1.357-1.615.849-.232 1.574-.787 2.132-1.41.56-.627.914-1.28 1.039-1.639.199-.575.356-1.539.428-2.59z"/>
        </svg>
        <p>{{ numberOfLikes }}</p>
      </div>
      <div v-if="imageDenied">
        <p class="image-denied-message">Image was not allowed by moderator. It will be deleted automatically.</p>
      </div>

    </div>
    <div>
      <svg id="delete-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16"
           class="bi bi-trash-fill selectable"
           viewBox="0 0 16 16" @click="deleteImage">
        <path
            d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5M8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5m3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0"/>
      </svg>
    </div>
  </div>
</template>

<script setup>
import apiService from '@/services/apiService';
import {onMounted, ref} from 'vue';
import {useRouter} from 'vue-router';
import {formatDateUS} from "../../util/dateUtil";

const emit = defineEmits(['deleteImage'])

const props = defineProps({
  imageUrl: String,
  title: String,
  description: String,
  publicationDate: Date,
  views: Number,
  published: Boolean,
  image_id: String,
  album_id: String,
  reviewed: Boolean,
  allowed_by_moderator: Boolean
})

const router = useRouter();
const signedUrl = ref('')
const imageDenied = ref(false);
const numberOfLikes = ref(0);

onMounted(async () => {
  await getSignedUrl();
  await getNumberOfLikes();
  checkBlockStatus();

});

async function getSignedUrl() {
  const response = await apiService.getImageSignedUrl(props.image_id);
  signedUrl.value = response.url;
}

async function getNumberOfLikes() {
  const response = await apiService.getNumberOfLikes(props.image_id);
  numberOfLikes.value = response.likes;
}

function goToDetail() {
  router.push(`/images/${props.image_id}`)
}

function checkBlockStatus() {
  imageDenied.value = props.reviewed && !props.allowed_by_moderator;
}

async function deleteImage() {
  await apiService.deleteImage(props.image_id)
  emit('deleteImage')
}
</script>

<style scoped>
.row-image-container {
  display: flex;
  align-items: start;
  justify-content: space-between;
  gap: 1rem;
  width: 100%;
  border: 1px solid lightgray;
  border-radius: 15px;
  margin: 0.5rem 0;
  padding: 0.5rem;
  box-sizing: border-box;
  height: 10rem;
}

.row-image-image {
  max-width: 30%;
  height: 9rem;
  display: flex;
  align-items: center;
  border-radius: 15px;
  overflow: hidden;
}

.row-image-image img {
  width: 100%;
  height: auto;
  border-radius: 15px;
}

.row-image-info {
  min-width: 60%;
}

.publish-state-container {
  display: flex;
  align-items: center;
  justify-content: start;
  gap: 0.3rem;
}

.publish-state-container p {
  margin: 0;
}

.image-likes-container {
  display: flex;
  align-items: center;
  justify-content: start;
  gap: 0.3rem;
}

.image-likes-container p {
  margin: 0;
}

.image-denied-message {
  font-size: 1rem;
  font-weight: bold;
  color: darkred;
}

.denied-by-mod {
  background: repeating-linear-gradient(
      45deg,
      white,
      white 5px,
      rgb(255 0 0 / 0.05) 5px,
      rgb(255 0 0 / 0.05) 10px
  );

  border: 2px solid darkred;
}

.upload-date {
  font-size: 0.8rem;
  font-weight: lighter;
  color: darkgray;
}

.review-message {
  color: rgb(213 61 35 / 0.84);
  font-size: 0.8rem;
  font-style: italic;
}

#delete-icon {
  fill: lightgray;
  transition: fill 0.2s ease-in-out;
}

#delete-icon:hover {
  fill: lightcoral;
}
</style>